import React, { useRef, useState, useEffect, useCallback } from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import { AvatarChange } from '../AvatarCrop';
import { Container, EditPhoto, PhotoOriginal, Title, Subtitle } from './styles';

interface Props {
  imageSrc?: string;
  isEdit: boolean;
  saveProfileImage?: (val: AvatarChange) => void;
}

const LogoResellerPhoto = ({ imageSrc, isEdit, saveProfileImage }: Props) => {
  const { t } = useStoreTranslation();

  const [file, setFile] = useState<File>();
  const [src, setSrc] = useState<string>();
  const [formatError, setFormatError] = useState(false);

  const inputRef = useRef<HTMLInputElement>(null);

  const handleUpload = () => {
    inputRef.current?.click();
  };

  useEffect(() => {
    if (file) {
        
        const data = new FormData();
        data.append('file', file);

        const reader = new FileReader();
        reader.readAsDataURL(file as File);
        reader.onload = () => {
            const imageBase64 = reader.result as string;

            const val: AvatarChange = {
            formData: data,
            image: imageBase64,
            };

            setSrc(reader.result as string);
            if (saveProfileImage) {
                saveProfileImage(val);
            }
        };        
    }
    }, [file]);


  const handleChangePhoto = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const newFile = event.target.files?.item(0) || undefined;
    if (newFile && !['image/png', 'image/jpeg'].includes(newFile.type)) {
      setFormatError(true);
      event.target.value = '';
      return;
    }
    setFormatError(false);
    setFile(newFile);
  }, []);

  return (
    <>
      <Container>
        <Title>{t('companyConfigurationForm.ownerImageLogo')}</Title>

        {isEdit && (
          <EditPhoto type="button" onClick={handleUpload}>
            <label>{t('companyConfigurationForm.editLogoReseller')}</label>
            <input type="file" accept="image/png, image/jpeg" ref={inputRef} onChange={handleChangePhoto} />
          </EditPhoto>
        )}
        {formatError && (
          <Subtitle style={{ color: 'red' }}>{t('companyConfigurationForm.logoFormatError')}</Subtitle>
        )}
        <Subtitle><i>{t('companyConfigurationForm.ownerImageLogoSubtitle')}</i></Subtitle>
        {src && src !== '' ? (
          <PhotoOriginal>
            <img src={src} alt="" />
          </PhotoOriginal>
        ) : (
          <PhotoOriginal>
            <img src={imageSrc && imageSrc !== '' ? imageSrc : '/corporate/images/logo-netviajes.svg'} alt="" />
          </PhotoOriginal>
        )}
        
      </Container>
    </>
  );
};

export default LogoResellerPhoto;
